import { useEffect, useRef, useState } from "react";
import { Button, CheckboxField } from "@common";

export default function ColumnToggle({ allColumns, hiddenColumns, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <Button variant="outline" size="sm" onClick={() => setOpen((v) => !v)}>
        <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L13 14.414V20a1 1 0 01-.553.894l-2 1A1 1 0 019 21v-6.586L3.293 6.707A1 1 0 013 6V4z"
          />
        </svg>
        Columns
        {hiddenColumns.size > 0 && (
          <span className="ml-1.5 inline-flex items-center justify-center rounded-full bg-palette-indigo-muted text-palette-indigo-heading text-xs font-medium min-w-[1.25rem] h-5 px-1">
            {hiddenColumns.size}
          </span>
        )}
      </Button>
      {open && (
        <div className="absolute right-0 mt-1 z-50 w-52 rounded-lg border border-palette-gray-divider bg-white shadow-lg py-1 max-h-72 overflow-y-auto">
          {allColumns.map((col) => (
            <div key={col.key} className="px-3 py-0.5 hover:bg-palette-gray-soft">
              <CheckboxField
                label={col.header}
                checked={!hiddenColumns.has(col.key)}
                onChange={() => onChange(col.key)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
